import { AlertCircle, CheckCircle, Clock, Crown } from "lucide-react";

const SubscriptionStatus = ({ subscriptionData }) => {
    const hasActiveSubscription =
    subscriptionData?.has_subscription 
    // &&
    // subscriptionData.subscription?.status === "active";
  return (
    <div className="border-t pt-2 mt-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1">
          <Crown className="w-3 h-3 text-amber-600" />
          <p className="text-xs text-secondary-500">Subscription</p>
        </div>
        <div
          className={`text-xs font-medium px-2 py-1 rounded-full ${
            hasActiveSubscription
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {
            hasActiveSubscription ? (
              <div className="flex items-center gap-1">
                <CheckCircle className="w-3 h-3" />
                <span>Active</span>
              </div>
            ) : (
              <div className="flex items-center gap-1">
                <AlertCircle className="w-3 h-3" />
                <span>Inactive</span>
              </div>
            )
            //   : (
            //     <div className="flex items-center gap-1">
            //       <Clock className="w-3 h-3" />
            //       <span>Pending</span>
            //     </div>
            //   )
          }
        </div>
      </div>
      {subscriptionData.subscription?.end_date && (
        <p className="text-xs text-secondary-500 mt-1">
          Renews{" "}
          {new Date(subscriptionData.subscription.end_date).toLocaleDateString(
            "en-US",
            {
              day: "numeric",
              month: "short",
              year: "numeric",
            }
          )}
        </p>
      )}
    </div>
  );
};

export default SubscriptionStatus;
